// extracted by mini-css-extract-plugin
module.exports = {"hover-seat-content":"hoverSeat_hover-seat-content__A1FIj"};